'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('paper-ballot-property-select', {
      url: '/voting/:voteId/record-paper-ballots/:ballotId',
      template: '<paper-ballot-property-select></paper-ballot-property-select>',
        authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/ballot/paper-ballot-property-select/paper-ballot-property-select.routes.js